import React from "react";
import { useSelector } from "react-redux";
import { GoldenRatio } from "components/models/GolderRatio";

function LogoSection({ height = null }) {
  const json = useSelector((state) => state.widgetJSON);
  const { B } = GoldenRatio({
    height: window.innerHeight - (window.innerHeight * 24) / 100,
  });
  const margin = (B * 19.2) / 100;

  return (
    <div
      // className="border"
      // xs={24}
      style={{
        // maxHeight: pages[currentPage]?.properties.is_page_title
        //   ? navCalc["companyPageTitle"]
        //   : navCalc["company"],
        maxHeight: height ? height : (B * 80.8) / 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexGrow: 1,
        marginTop: height ? 0 : margin,
      }}
    >
      <img
        src={json?.data?.general_settings?.logo_url}
        className="img-fluid"
        style={{
          width: "61.4%",
          height: "85%",
          objectFit: "contain",
        }}
        alt="Company_logo"
      />
    </div>
  );
}

export default LogoSection;
